import { HttpClientHeaders } from '../httpClient/IHttpClient';

export enum ServerSentEventErrorTypes {
    ABORTED = 'ABORTED',
    HTTP_ERROR = 'HTTP_ERROR',
    CONNECTION_ERROR = 'CONNECTION_ERROR',
    STREAM_TIMEOUT = 'STREAM_TIMEOUT',
}

export class ServerSentEventError extends Error {
    static isServerSentEventError(error: unknown): error is ServerSentEventError {
        return error instanceof ServerSentEventError;
    }

    constructor(
        public errorType: ServerSentEventErrorTypes,
        public code?: string,
        message?: string,
        public responseHeaders?: HttpClientHeaders,
    ) {
        super(message ?? 'HTTP request failed');
        this.message = message ?? 'HTTP request failed';
    }

}
